import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes (especially important for footer links)
    // With flexbox layout, the content div scrolls, not the window

    // First try to find and scroll the flex-1 overflow-auto content div
    const contentDiv = document.querySelector('.flex-1.overflow-auto') as HTMLElement;
    if (contentDiv) {
      contentDiv.scrollTop = 0;
    }

    // Fallback: Also scroll window/body for pages not using flexbox layout
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;